<!--
@author wyr
@date 2021/11/26 15:00
-->
<template>
  <!--更多筛选项-->
  <div @mouseleave="active=null" class="par-box">
    <div class="total-box">
      <span class="label" :style="{width:labelWidth}">更多选项：</span>
      <el-button :class="active==index?'active':'buttitle'" :key="index" v-for="(item,index) in filterLableList" @mouseenter.native.stop="active=index">
        <i v-if="item.index==index&&(typeof obj[item.key] == 'string'?obj[item.key]:(typeof obj[item.key] == 'number'?obj[item.key]!=null:obj[item.key].length>0))" class="el-icon-deytyuanquan"></i> {{item.name}}
        <i v-if="active==index" class="el-icon-arrow-up"></i><i v-else class="el-icon-arrow-down"></i>
      </el-button>
    </div>
    <div>
      <el-card v-if="active!=null" :style="{left:labelWidth}" class="title-sub" @mouseleave.native="active=null"><slot :name="active"></slot></el-card>
    </div>
  </div>
</template>

<script>
    export default {
        name: "more-filter",
        props:{
          labelWidth:{
            type:String,
            default:'80px'
          },
          obj:{
            type:Object,
            default:()=>({})
          },
          filterLableList:{
            type:Array,
            default:()=>([])
          }
        },
        data() {
            return {
              active:null
            }
        },
        mounted() {
        },
        methods: {}
    }
</script>

<style lang="scss" scoped>
  .par-box{position: relative;}
  .label{text-align: right;padding-right: 5px;box-sizing: border-box;}
  .total-box{display: flex;align-items: center;margin-bottom: 10px;}
  .box-card{width: 180px;height: 30px;}
  .total-box /deep/ .el-button+.el-button {
    margin-left: 0px;
  }
  .total-box .el-button {
    border-radius: 0px;
  }
  .buttitle{
    padding: 10px 15px;
    z-index: 1;
    // border: 0.5px solid #999;
  }
  .active{opacity: 1;color: #409EFF;padding: 10px 15px;border-bottom: medium none;z-index: 9999;}
  .title-sub{
    position: absolute;
    top: 35px;
    left: 80px;
    // width: calc(100%-20px);
    width: 1100px;
    border-bottom:0.1px solid rgb(230, 230, 230);
    background: #fff;padding: 5px 10px;font-size: 16px;color: #999;font-weight: bold; z-index:999;}
  /deep/ .el-card.is-always-shadow, /deep/.el-card.is-hover-shadow:focus, /deep/.el-card.is-hover-shadow:hover { -webkit-box-shadow: none;box-shadow: none;margin-bottom: 10px;}
</style>



// WEBPACK FOOTER //
// src/components/more-filter.vue